import { makeStyles } from "@material-ui/core/styles";

const drawerWidth = 240;
const mobileFooterHeight = 64;
const theme = (props) => {
  const styles = makeStyles(theme => ({
    root: {
      display: 'flex',
      overflowX: 'hidden'
    },
    appBar: {
      height: 60,
      backgroundColor: 'white',
      zIndex: theme.zIndex.drawer + 1,
      fontSize: 13,
      color: '#989898',
      textTransform: 'uppercase'
    },
    appBarToolbar: {
      justifyContent: 'space-between',
      paddingLeft: 0,
      height: 60,
      minHeight: 60,
    },
    appBarToolbarLanguage: {
      width: 40,
      height: 25,
      cursor: "pointer"
    },
    appToolbarLanguagePaper: {
      padding: 10,
      position: "absolute",
      left: -9,
      top: 35
    },
    appBarToolbarUser: {
      width: drawerWidth + 100,
      height: 60,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    appBarToolbarUserName: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    appBarToolbarLogout: {
      fontSize: 26,
      fontWeight: 'bold',
      fill: 'rgba(152,152,152,0.4)',
      cursor: 'pointer'
    },
    responsiveMenuToolbar: {
      display: 'inline-flex',
      alignItems: 'center',
      width: drawerWidth,
      borderBottom: '3px solid transparent',
      // marginBottom: -2,

    },
    appBarToolbarLogo: {
      backgroundColor: props.logoBg,
      backgroundImage: `url("${props.logoPath}")`,
      width: drawerWidth,
      height: 60,
      backgroundPosition: 'left',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '80%',
      borderBottom: `3px solid ${props.color4}`,
    },
    appBarToolbarSmallLogo: {
      backgroundImage: `url("${props.logoSmallPath}")`,
      width: 100,
      height: 60,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100%',
    },
    menuOpen: {
      borderBottom: `3px solid ${props.color4}`,
    },
    appBarToolbarUserIcon: {
      height: 50,
      width: 50,
      borderRadius: '50%'
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      boxSizing: 'border-box',
      marginTop: 60,
      padding: 15,
      width: '100%',
    },

    contentWithFooter: {
      paddingBottom: `calc(${mobileFooterHeight}px + env(safe-area-inset-bottom) + 16px)`,
    },

    mobileFooterNav: {
      position: 'fixed',
      left: 0,
      right: 0,
      bottom: 0,

      width: '100%',
      zIndex: theme.zIndex.modal + 4,
      background: '#fff',
      borderTop: '1px solid rgba(0,0,0,0.12)',
      paddingBottom: 'env(safe-area-inset-bottom)',
      '& .MuiBottomNavigation-root': {
        height: mobileFooterHeight,

      },
      '& .MuiBottomNavigationAction-root': {
        color: props.footerIconColor || '#757575',
        minWidth: 0,
        paddingTop: 6,

      },
      '& #dashboard-mobile-nav-contacts .MuiBottomNavigationAction-label': {
        marginTop: 2,
      },

      '& .MuiBottomNavigationAction-root.Mui-selected': {
        color: props.footerSelectedIconColor || props.color4,
      },
      '& .MuiBottomNavigationAction-root.Mui-selected .MuiBottomNavigationAction-label': {
        color: props.footerSelectedTextColor || props.color4,
      },
    },

    mobileSheetPaper: {
      position: 'fixed',
      left: 8,
      right: 8,
      bottom: mobileFooterHeight,        // key: starts from footer edge
      width: 'auto',
      borderTopLeftRadius: 18,
      borderTopRightRadius: 18,
      paddingBottom: 12,
      maxHeight: '70vh',
      overflowY: 'auto',
    },
    mobileSheetHandle: {
      width: 42,
      height: 4,
      borderRadius: 2,
      background: '#C9CDD3',
      margin: '10px auto 6px auto',
    },
    appBarMobile: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      height: 60,
      backgroundColor: `${props.logoBg}`,
      borderBottom: `3px solid ${props.color4}`,
      zIndex: theme.zIndex.appBar + 2,
    },

    appBarToolbarMobile: {
      justifyContent: 'space-between',
      paddingLeft: 8,
      paddingRight: 8,
      height: 60,
      minHeight: 60,
    },

    responsiveMenuToolbarMobile: {
      display: 'inline-flex',
      alignItems: 'center',
      width: 'auto',
      minWidth: 110,
      height: 60,
      borderBottom: 'none',

    },

    appBarToolbarUserMobile: {
      width: 'auto',
      height: 60,
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: 8,
      marginLeft: 'auto',
    },
    appBarToolbarLanguageMobile: {
      width: 32,
      height: 20,
      cursor: 'pointer'
    },

    appBarToolbarUserIconMobile: {
      height: 36,
      width: 36,
      borderRadius: '50%',
      filter: 'brightness(1.25) contrast(1.15)',
      boxShadow: '0 0 0 2px rgba(255,255,255,0.35), 0 2px 8px rgba(0,0,0,0.25)',
      backgroundColor: 'rgba(255,255,255,0.3)',
      padding: 2,
    },
    appBarToolbarUserNameMobile: {
      display: 'inline-block',
      marginLeft: 12,
      marginRight: 4,
      maxWidth: 120,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: 13,
      color: props.color1 || '#333',
    },
  }));
  return styles();
}
export default theme;

